import { store } from '@redux/store';
import { debounceTime, fromEvent, map, merge, of, switchMap } from "rxjs";
import { selectPage, articleSearchResultsActions } from 'features/articleSearchResultsFacets';

const getLinkAbleElement = (event) => event.target.closest('[data-page-link]');
const paginationContainer = document.querySelector('[data-component="article-search-results-pagination"]');
const previousButton = paginationContainer.querySelector('[data-prev-button]');
const nextButton = paginationContainer.querySelector('[data-next-button]');
const optionList = paginationContainer.querySelector('[data-option-list]');

/**
 * Observable that listens for clicks on the "Previous" button and emits the new page number.
 * @type {Observable<number>}
 */
const previousButton$ = fromEvent(previousButton, 'click').pipe(
  map(() => selectPage(store.getState())),
  map((currentPage) => currentPage - 1)
);

/**
 * Observable that listens for clicks on the "Next" button and emits the new page number.
 * @type {Observable<number>}
 */
const nextButton$ = fromEvent(nextButton, 'click').pipe(
  map(() => selectPage(store.getState())),
  map((currentPage) => currentPage + 1)
);

/**
 * Observable that listens for clicks on the pagination options and emits the selected page number.
 * @type {Observable<number>}
 */
const optionList$ = fromEvent(optionList, 'click').pipe(
  switchMap((event) => {
    const linkableElement = getLinkAbleElement(event);
    if (linkableElement) {
      event.preventDefault();
    }
    const page = Number(linkableElement?.dataset?.pageLink || 0);
    return of(page);
  })
);

/**
 * Updates the page number in the Redux store.
 * @param {number} newPageNumber - The new page number to update.
 */
const updatePageNumber = function(newPageNumber) {
  store.dispatch(articleSearchResultsActions.updatePageParameter(newPageNumber));
};

/**
 * Merges all pagination-related observables and listens for page changes.
 * Debounces the events to prevent rapid consecutive updates.
 * @type {Observable<number>}
 */
const pageChange$ = merge(previousButton$, nextButton$, optionList$).pipe(debounceTime(100));
pageChange$.subscribe(updatePageNumber);